import { State } from 'types';
import { Appointment } from 'EntityTypes';

export const getAppointment = (
  state: State,
  { appointmentId }: { appointmentId: number },
): Appointment =>
  state.entities.appointments ? state.entities.appointments[appointmentId] : undefined;
